import { animate } from "motion"
export function motionCount(countElement) {
    // Grab some values as a string from item data attr and convert to an number for use
    let start = +countElement.getAttribute('data-start') || 0;
    let end = countElement.getAttribute('data-end') || 0;
    let duration = +countElement.getAttribute('data-duration') || 0.25;
    // Split all of the characters (e.g ',' or '.' '12,500.45') so we can animate each number individually
    let characters = end.split('');
    // Empty the container
    countElement.innerHTML = '';
    // Loop over each character, create a new container, add that container to original container
    // If character is a number when converting using the '+' then we animate with a slight stagger
    // Else just append the original character (',' or '.') back in
    characters.forEach((character, index) => {
        let span = document.createElement('span');
        countElement.appendChild(span);
        if (!isNaN(+character)) {
            animate(start, +character, {
                duration: duration + (index * 0.01),
                ease: "linear",
                onUpdate: (latest) => {
                    span.innerHTML = Math.round(latest);
                },
            });
        } else {
            span.innerHTML = character;
        }
    });
}